<template>
    <div class="sales-modal-action" v-if="setup != null && openModal">
        <a href="#" @click.prevent="closeModal" class="close-form-link">
            <svg-icon icon-class="close" className="share-icon icon-close"/>
        </a>
        <div class="images">
            <div class="img-left">
                <img src="https://sales.bazis.kz/cms/media/2022/06/action-title.png" alt="">
            </div>
            <div class="img-right">
                <img src="https://sales.bazis.kz/cms/media/2022/06/action-house.png" alt="">
            </div>
        </div>
        <div class="form-sales-modal-action">
            <h3>Заполните заявочную форму <br>и получите свою персональную скидку</h3>
            <formCovid></formCovid>
        </div>
    </div>
</template>

<script>
    import formCovid from '@/components/forms/form-covid.vue'
    import {mapGetters} from 'vuex'
    export default {
        name: 'sales-modal',
        components: {
            formCovid,
            // formSignupProject,
        },
        data () {
            return {
                routerName: this.$router.history.current.name,
                banerArr: null,
                isMobile: false,
            }
        },
        computed: mapGetters({
            setup: 'loadPageSetUp',
            openModal: 'loadSalesModalAction',
        }),
        methods: {
            closeModal() {
                this.$cookie.set('summerSalesModal', true, { expires: '1D' });
                this.$store.commit('openSalesModalAction', false);
                document.getElementsByTagName('body')[0].classList.remove('overlay-open-sales-modal');
            }
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/partials/sales-modal.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>